import { Navigate } from 'react-router-dom';
import { ROUTERS } from '../data';
import { getAuthToken } from '../services';

export const ProtectedRoute = ({ children }: { children: any }) => {
  if (getAuthToken()) {
    return children;
  } else {
    return <Navigate to={ROUTERS.INIT} />;
  }
};
